"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageHelper = void 0;
const teamsLogoImg = require("../images/v2/logo_teams.svg");
const teamsLogoImg2025 = require("../images/v2/logo_teams2025.svg");
const teamsButtonLogoImg = require("../images/v3/logo_teams.svg");
const teamsButtonLogoImg2025 = require("../images/v3/logo_teams2025.svg");
class ImageHelper {
    static getTeamsLogo(featureFlags) {
        return featureFlags.enable2025BrandIcons ? teamsLogoImg2025 : teamsLogoImg;
    }
    static getTeamsButtonLogo(featureFlags) {
        return featureFlags.enable2025BrandIcons ? teamsButtonLogoImg2025 : teamsButtonLogoImg;
    }
}
exports.ImageHelper = ImageHelper;
